import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { checkHealth } from '../api/articles';
import '../styles/HomePage.css';

const HomePage: React.FC = () => {
  const [healthStatus, setHealthStatus] = useState<string | null>(null);

  useEffect(() => {
    checkHealth()
      .then((data) => {
        console.log('Health check:', data);
        setHealthStatus(data.status);
      })
      .catch((error) => {
        console.error('Health check failed:', error);
        setHealthStatus('error');
      });
  }, []);

  return (
    <div className="home-container">
      <span className="emoji">🚀</span>
      <h1>Space Radar</h1>
      <p>FastAPI 서버가 성공적으로 실행 중입니다!</p>

      <div className="status-badge">
        {healthStatus === 'ok' ? '✓ Server Running' : healthStatus === 'error' ? '✗ Server Error' : '...'}
      </div>

      <div className="edit-link">
        <Link to="/edit">기사 목록 바로가기</Link>
      </div>
    </div>
  );
};

export default HomePage;
